import { Star, Quote } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Marie",
      location: "Villard-Bonnot",
      rating: 5,
      text: "Un travail remarquable ! Notre cuisine sur mesure est exactement ce que nous avions imaginé. L'équipe a été à l'écoute de nos besoins du début à la fin. Je recommande vivement TTWood.",
      project: "Cuisine sur mesure",
    },
    {
      name: "Martine",
      location: "Grenoble",
      rating: 5,
      text: "Notre bibliothèque sur mesure est magnifique ! Elle s'intègre parfaitement dans notre salon et la qualité du bois est exceptionnelle. Un vrai travail d'artisan, merci TTWood !",
      project: "Bibliothèque sur mesure",
    },
    {
      name: "Sophie",
      location: "Meylan",
      rating: 5,
      text: "Nous avons fait appel à TTWood pour notre terrasse et nous sommes enchantés. Le bois est magnifique et la finition impeccable. Un artisan passionné !",
      project: "Terrasse bois",
    },
  ];

  return (
    <section
      id="temoignages"
      className="py-20 md:py-32 bg-white relative"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-forest-green font-medium text-sm uppercase tracking-wider">
            Témoignages
          </span>
          <h2 
            className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-deep-oak mt-3 mb-6"
            data-testid="testimonials-title"
          >
            Ce que Disent nos Clients
          </h2>
          <p className="text-text-secondary text-base md:text-lg">
            La satisfaction de nos clients est notre plus belle récompense. 
            Découvrez leurs retours d'expérience.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="testimonial-card relative"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <Quote className="absolute top-6 right-6 w-10 h-10 text-deep-oak/10" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-text-secondary text-sm leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-12 h-12 rounded-full bg-deep-oak/10 flex items-center justify-center">
                  <span className="text-deep-oak font-semibold text-lg">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-medium text-deep-oak">{testimonial.name}</p>
                  <p className="text-text-muted text-xs">
                    {testimonial.location} • {testimonial.project}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
